import Styles from "./Mob.module.css"
import { Grid2, Typography, Box } from "@mui/material";
import tech from "../../../../ui-utils/latestPics/technology.gif"
import research from "../../../../ui-utils/latestPics/research.gif"
import training from "../../../../ui-utils/latestPics/training.gif"
import market from "../../../../ui-utils/latestPics/marketSup.gif"
import { AnimationOnScroll } from "react-animation-on-scroll";
import en from "../../../../i18n/English/Partner/details.json";
import hi from "../../../../i18n/Hindi/Partner/details.json";
import kn from "../../../../i18n/Kannada/Partner/details.json";
import ma from "../../../../i18n/Marathi/Partner/details.json";
import gu from "../../../../i18n/Gujarati/Partner/details.json";
import { useLanguage } from "../../../../Context/LangContext";
export default function InfoMob() {
    const { language } = useLanguage();
    const translations = { en, hi, kn, gu, ma };
    const t = translations[language];
    return (
        <>
            <Box
                className={Styles.outerBox}
            >
                {/* <AnimationOnScroll animateIn="animate__fadeInDown"
                    animateOnce={true}
                    style={{ "--animate-duration": "0.5s" }}> */}

                <Typography
                    className={Styles.heading}
                >
                    {t.heading}
                </Typography>
                {/* </AnimationOnScroll> */}
                <Box
                    className={Styles.innerBox}>
                    <Box sx={{ width: "100%" }}>

                            <Grid2 size={6}>
                                {/* <Item>2</Item> */}
                                <Box className={Styles.card}>
                                    <Box
                                        component="img"
                                        src={research}
                                        alt="Customizable Trading Bots"
                                        sx={{ marginTop: "32px", }}
                                        className={Styles.pic}

                                    />
                                    <Typography
                                        // variant="h6"
                                        className={Styles.title}
                                    >
                                    {t.cards[0].title}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        className={Styles.subtitle}
                                    >
                                    {t.cards[0].subtitle}
                                    </Typography>
                                </Box>
                            </Grid2>
                            <Grid2 size={6}>
                                {/* <Item>1</Item> */}
                                <Box className={Styles.card}>
                                    <Box
                                        component="img"
                                        src={tech}
                                        alt="Multi Exchange Access"
                                        className={Styles.pic}
                                    />
                                    <Typography
                                        // variant="h6"
                                        className={Styles.title}
                                    >
                                    {t.cards[1].title}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        className={Styles.subtitle}
                                    >
                                    {t.cards[1].subtitle}
                                    </Typography>
                                </Box>
                            </Grid2>
                            <Grid2 size={6}>
                                {/* <Item>4</Item> */}
                                <Box className={Styles.card}>
                                    <Box
                                        component="img"
                                        src={market}
                                        alt="Optimized Trading Strategies"
                                        sx={{
                                            marginTop: "32px",

                                        }}
                                        className={Styles.pic}
                                    />
                                    <Typography
                                        // variant="h6"
                                        className={Styles.title}
                                    >
                                    {t.cards[2].title}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        className={Styles.subtitle}
                                    >
                                    {t.cards[2].subtitle}
                                    </Typography>
                                </Box>
                            </Grid2>
                            <Grid2 size={6}>
                                {/* <Item>3</Item> */}
                                <Box className={Styles.card}>
                                    <Box
                                        component="img"
                                        src={training}
                                        alt="Diverse Portfolio Management"
                                    sx={{  marginTop: "32px", }}
                                    className={Styles.pic}

                                    />
                                    <Typography
                                        // variant="h6"
                                        className={Styles.title}
                                    >
                                    {t.cards[3].title}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        className={Styles.subtitle}
                                    >
                                    {t.cards[3].subtitle}
                                    </Typography>
                                </Box>
                            </Grid2>


                    </Box>
                </Box>
            </Box>
        </>
    )
}